import { Component, Vue, Prop } from "vue-property-decorator";

@Component({
  components: {},
})
export default class VLoginButton extends Vue {
  @Prop() styleType!: "white" | "black";

  get isLoginPage() {
    return this.$route.name === "Login";
  }

  get isAuthenticated() {
    return this.$store.state.auth.isAuthenticated;
  }

  showReturnText() {
    return this.$route.name === "Registration";
  }

  goToLogin() {
    if (this.isAuthenticated) {
      this.$store.dispatch("auth/logout");
      if (this.$route.name !== "Home") {
        this.$router.push({ name: "Home" });
      }
    } else {
      this.$router.push({ name: "Login" });
    }
  }
  goToRegister() {
    this.$router.push({ name: "Registration" });
  }
}
